<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-md-center">
            <b-col xl="12">
                <b-card class="edit-order-card">
                    <div class="order-details-body">
                        <div class="order-details-content">
                            <div class="order-details">
                                <div class="about-client">
                                    <h4>{{'Order ID #' + orderDetails.orderId}} <span>{{orderDetails.dateCreated}}</span></h4>
                                    <h3 class="client-header">Client</h3>
                                    <h4 class="client-name">{{orderDetails.companyName}}</h4>
                                    <p class="client-data">{{orderDetails.companyAddress.address1}},</p>
                                    <p v-if="orderDetails.companyAddress.address2" class="client-data">{{orderDetails.companyAddress.address2}},</p>
                                    <p class="client-data">{{orderDetails.companyAddress.city}},</p>
                                    <p class="client-data">{{orderDetails.companyAddress.state}} {{orderDetails.companyAddress.postalCode}}, {{orderDetails.companyAddress.country}}</p>
                                    <p class="client-contact-header">Contact number</p>
                                    <p v-if="orderDetails.shippingAddress.contactNumber" class="client-contact-number">{{orderDetails.shippingAddress.contactNumber.asString}}</p>
                                </div>
                                <div class="edit-order-status">
                                    <h4>Order status</h4>
                                    <h5>In progress</h5>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="open-status" value="CREATED" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="open-status">Open</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="processing-status" value="CONFIRMED" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="processing-status">Processing</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="packaging-status" value="PAID" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="packaging-status">Packaging</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="pickup-status" value="PACKED" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="pickup-status">Waiting for pickup</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="shipped-status" value="SHIPPED" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="shipped-status">Shipped</label>
                                    </div>
                                    <h5>Closed</h5>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="canceled-status" value="CANCELLED" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="canceled-status">Canceled</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="order-status" id="completed-status" value="COMPLETED" v-model="currentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="completed-status">Completed</label>
                                    </div>
                                    <h5 v-if="orderDetails.postPaid == true">Payment</h5>
                                    <div v-if="orderDetails.postPaid == true " class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="payment-status" id="waiting-payment" value="WAITING" v-model="paymentStatus" @change="changeOrderDetails()">
                                        <label class="custom-control-label" for="waiting-payment">Waiting</label>
                                    </div>
                                    <div v-if="orderDetails.postPaid == true " class="custom-control custom-radio custom-control-inline">
                                        <input class="custom-control-input" type="radio" name="payment-status" id="paid-status" value="PAID" v-model="paymentStatus" @change="checkStatus()">
                                        <label class="custom-control-label" for="paid-status">Paid</label>
                                    </div>
                                </div>
                            </div>
                            <div class="temp-class">
                                <div class="ordered-items">
                                    <div class="order-header">
                                        <i v-on:click="cancelEdition()" class="fa fa-close"></i>
                                    </div>
                                    <table class="summary-table">
                                        <thead>
                                            <tr>
                                                <th>Item</th>
                                                <th>Carrier</th>
                                                <th>Quantity</th>
                                                <th>Price</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="cost-row" v-for="item in orderDetails.orderItems">
                                                <td>
                                                    <div class="item-box">
                                                        <div class="img-box">
                                                            <img class="light-mode" :src="item.item.lightCarrierImage"/>
                                                            <img class="dark-mode" :src="item.item.darkCarrierImage"/>
                                                        </div>
                                                        <span class="item-name">{{item.item.description}}</span>
                                                    </div>
                                                </td>
                                                <td>{{item.item.carrier.carrierName}}</td>
                                                <td>{{item.itemQuantity}}</td>
                                                <td>{{(item.item.unitPrice).toFixed(2)}}</td>
                                                <td>$ {{((item.itemQuantity * item.item.unitPrice)).toFixed(2)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <h4 v-if="orderDetails.taxApplied">Tax</h4>
                                    <div v-if="orderDetails.taxApplied" class="order-tax">
                                        <span>NYS Sales Tax</span>
                                        <span>$ {{orderDetails.taxApplied}}</span>
                                    </div>
                                    <h4>Shipment</h4>
                                    <div class="order-shipment">
                                        <span>{{orderDetails.shippingOption.displayName}}</span>
                                        <span>$ {{orderDetails.shippingOption.price}}</span>
                                    </div>
                                    <h4>Ship to:</h4>
                                    <div class="order-ship-address">
                                        {{orderDetails.shippingAddress.addressLine1}}
                                        {{orderDetails.shippingAddress.addressLine2}},
                                        {{orderDetails.shippingAddress.city}},
                                        {{orderDetails.shippingAddress.state}} {{orderDetails.shippingAddress.postalCode}}, {{orderDetails.shippingAddress.country}}
                                    </div>
                                    <h4>Cold Stock</h4>
                                    <div class="cold-stock">
                                        <button class="btn btn-primary" v-on:click="openColdStockModal()">Add to Cold Stock</button>
                                        <div v-if="coldStockValidated">
                                            <span>Blank SIM cards added: {{coldStockValidated}}/{{coldStockValidated}}</span>
                                            <span class="validated success"> Validated</span>
                                        </div>
                                    </div>
                                    <h4 v-if="orderDetails.discountApplied > 0">Cupon</h4>
                                    <div v-if="orderDetails.discountApplied > 0" class="coupon-information">
                                        For this order was used coupon with $ {{orderDetails.discountApplied}} discount.
                                    </div>
                                    <h4>Tracking Number</h4>
                                    <div class="tracking-control">
                                        <div class="add-tracking">
                                            <input type="text" placeholder="Enter Tracking Number" v-model="newTracking" @keyup.enter="addTracking()">
                                            <button @click="addTracking()">Add</button>
                                        </div>
                                        <div v-for="tracking in orderDetails.trackingNumbers" class="tracking-number">
                                            <span>{{tracking}}</span>
                                            <i class="fa fa-close" @click="removeTracking(tracking)"></i>
                                        </div>
                                    </div>
                                    <h4 v-if="currentStatus != 'CREATED'">Payment</h4>
                                    <div v-if="orderDetails.creditCardInfo && orderDetails.postPaid == false && currentStatus != 'CREATED'" class="payment">
                                        <div class="card-info">
                                            <img :src="require('../../assets/img/' + creditCardImg)" alt="card-logo">
                                            <span class="card-number">{{orderDetails.creditCardInfo.cardDescription}}</span>
                                        </div>
                                        <div class="payment-status-box">
                                            <span :class="['payment-status', orderDetails.datePaid != null ? [orderDetails.status != 'PAYMENT_ERROR' ? 'succes' : 'failed'] : '']">{{orderDetails.datePaid != null ? (orderDetails.status != 'PAYMENT_ERROR' ? 'Payment confirmed' : 'Payment failed') : 'Payment in progress'}}</span>
                                            <span v-if="orderDetails.status != 'PAYMENT_ERROR' && orderDetails.datePaid != null" class="payment-date">{{orderDetails.datePaid}}</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <p>This company has no credit card on file.</p>
                                    </div>
                                    <div v-if="orderDetails.postPaid == true && currentStatus != 'CREATED'">
                                        This order is Postpaid
                                    </div>
                                    <div class="order-total">
                                        <span>Total cost</span>
                                        <h3>$ {{orderDetails.totalPrice}}</h3>
                                        <span>inc. $ {{orderDetails.shippingOption.price}} shipping</span>
                                    </div>
                                </div>
                                <div class="control-bar">
                                    <input id="sendUpdated" v-model="sendEmail" type="checkbox" @change="checkSendEmail()">
                                    <label for="sendUpdated">Send status update to client</label>
                                    <button class="btn btn-light" v-on:click="cancelEdition()">Cancel</button>
                                    <button class="btn btn-success" :disabled="noChange.tracking && noChange.emails && noChange.status" @click="sendChanges">OK</button>
                                </div>
                            </div>
                        </div>

                        <div class="loader-request-execution" v-if="loading">
                            <div class="sk-wave">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                            </div>
                            <h3>Data is sending to the database...</h3>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <b-modal size="md" ref="selectCarrier" id="selectCarrier" centered hide-header hide-footer> <!-- here -->
            <div class="close-bar">
                <i class="fa fa-close" @click="closeSelectCarrier()"></i>
            </div>
            <img src="../../assets/img/sim-card4.png" alt="">

            <strong>Select Carrier</strong>
            <p>Choose a cold stock sim carrier</p>

            <div class="select-carrier-box">
                <div v-if="simonCarrierAvailable" @click="showAddColdStock(1)" class="carrier-option" id="simonCarrierSelect">
                    <label for="simon-carrier">
                        <img src="../../assets/img/lightlogo.svg" class="light-mode" alt="">
                        <img src="../../assets/img/darklogo.svg" class="dark-mode" alt="">
                    </label>
                </div>
                <div v-if="tmobileCarrierAvailable" @click="showAddColdStock(2)" class="carrier-option" id="tmobileCarrierSelect">
                    <label for="t-mobile-carrier">
                        <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                        <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-mode">
                    </label>
                </div>
                <div v-if="vodafoneCarrierAvailable" @click="showAddColdStock(3)" class="carrier-option">
                    <label for="vodafone-carrier">
                        <img src="../../assets/img/vodafone-logo.svg" alt="" class="light-mode" id="vodafoneCarrierSelect">
                        <img src="../../assets/img/vodafone-logo.svg" alt="" class="dark-mode">
                    </label>
                </div>
                <div v-if="koreCarrierAvailable" @click="showAddColdStock(4)" class="carrier-option">
                    <label for="kore-carrier">
                        <img src="../../assets/img/kore-logo.svg" alt="" class="light-mode" id="koreCarrierSelect">
                        <img src="../../assets/img/kore-logo.svg" alt="" class="dark-mode">
                    </label>
                </div>
            </div>
        </b-modal>
        <b-modal size="md" ref="unsavedOrderEdition" id="unsavedOrderEdition" centered hide-footer hide-header>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Unsaved Data</h3>
            <h4>Order Edition will not be saved, do you wan to continue?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['unsavedOrderEdition'].hide()">Cancel</b-button>
                <b-button variant="success" @click="backToOrderManagement()">Continue</b-button>
            </div>
        </b-modal>

        <b-modal size="md" ref="unsavedChanges" id="unsavedChanges" centered hide-footer hide-header>
            <img  src="../../assets/img/unsaved-data.png" alt />

            <h3>Unsaved Data</h3>
            <h4>Order edition will not be saved, do you wan to continue?</h4>
            <div class="button-wrapper">
                <b-button variant="danger" @click="$refs['unsavedChanges'].hide()">Cancel</b-button>
                <b-button variant="success" @click="backToOrderManagement()">Continue</b-button>
            </div>
        </b-modal>

        <ColdStock v-if="coldStock" :closeModal="closeColdStock" @validated="validatedCount" :orderData="orderDetails" :carrierId="coldStock" :companyId='orderDetails.companyId' :addToCompany="true"></ColdStock>
    </div>
</template>

<script>
    import ColdStock from "./ColdStock";
    import globalStore from "../../variables";
    import Axios from "axios";

    export default {
        name: "EditOrder",
        components: {
            ColdStock: ColdStock
        },
        data () {
            return {
                orderId: null,
                coldStock: false,
                orderDetails: {
                    orderId: '',
                    companyId: '',
                    quantity: '',
                    totalPrice: '',
                    priceBeforeTaxation: '',
                    taxApplied: '',
                    currency: '',
                    creditCardInfo: {
                        creditCardId: '',
                        cardDescription: ''
                    },
                    shippingAddress: {
                        id: 11,
                        addressName: '',
                        contactNumber: '',
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        postalCode: '',
                        country: '',
                        state: ''
                    },
                    shippingOption: {
                        id: 2,
                        displayName: '',
                        range: '',
                        price: 0,
                        sortOrder: 0,
                        shippingDays: ''
                    },
                    dateCreated: '',
                    status: '',
                    statusMessage: '',
                    type: '',
                    carrier: {
                        carrierId: 0,
                        carrierName: '',
                        signoffRequired: null,
                        eligibilityCheckRequired: null
                    },
                    companyName: '',
                    unitValue: 0,
                    volume: 0,
                    companyAddress: {
                        city: '',
                        postalCode: '',
                        country: '',
                        phoneNumber: '',
                        state: '',
                        defaultAddress: 0,
                        address1: '',
                        address2: ''
                    },
                    datePaid: '',
                    trackingNumbers: [],
                    suppressEmails: true,
                },
                creditCardImg: '',
                currentStatus: null,
                newTracking: '',
                initialStatus: null,
                initialTracking: [],
                coldStockValidated: null,
                sendEmail: true,
                initialSendEmail: true,
                paymentStatus: 'WAITING',
                loading: false,
                noChange: {
                    status: true,
                    tracking: true,
                    emails: true
                },
                simonCarrierAvailable: false,
                tmobileCarrierAvailable: false,
                vodafoneCarrierAvailable: false,
                koreCarrierAvailable: false
            }
        },
        methods: {
            closeColdStock() {
                this.coldStock = false;
            },
            closeSelectCarrier() {
                this.$refs['selectCarrier'].hide();
                this.coldStock = false;
            },
            showAddColdStock(id) {
                this.$refs['selectCarrier'].hide();
                this.coldStock = id;
            },
            openColdStockModal() {
                this.$refs['selectCarrier'].show();
            },
            cancelEdition() {
                if (this.noChange.tracking && this.noChange.status && this.noChange.emails) {
                    this.backToOrderManagement();
                } else {
                    this.$refs['unsavedOrderEdition'].show();
                }
            },
            backToOrderManagement() {
                let fullPath = this.$router.history.current.path

                if (fullPath.indexOf('admin') > -1) {
                    this.$router.push('/admin/order-management')
                } else {
                    this.$router.push("/fulfilment/order-management");
                }
            },
            clickBackToOrderManagement() {
                if (this.changed.sendEmail || this.changed.orderDetails || this.changed.tracking) {
                    this.$refs['unsavedChanges'].show();
                } else {
                    this.backToOrderManagement();
                }
            },
            getOrderDetails(orderId) {
                Axios.get(globalStore.data.restApiUrl + "/orders/admin/" + orderId)
                    .then(result => {
                        this.orderDetails = result.data;
                        this.orderDetails.dateCreated = this.orderDetails.dateCreated;
                        if (this.orderDetails.datePaid != undefined) {
                            this.orderDetails.datePaid = this.orderDetails.datePaid;
                        } else {
                            this.orderDetails.datePaid = null;
                        }

                        if (this.orderDetails.creditCardInfo && this.orderDetails.postPaid == false) {
                            this.creditCardImg = this.orderDetails.creditCardInfo.cardDescription.slice(0, this.orderDetails.creditCardInfo.cardDescription.indexOf('*')) + '-icon.svg';
                        }

                        if (result.data.status != 'PAYMENT_ERROR') {
                            this.currentStatus = this.orderDetails.status;
                            this.initialStatus = this.currentStatus;
                        } else {
                            this.currentStatus = 'CONFIRMED';
                            this.initialStatus = this.currentStatus;
                        }

                        if (result.data.trackingNumbers != undefined) {
                            this.orderDetails.trackingNumbers = result.data.trackingNumbers;
                            for (let track of result.data.trackingNumbers) {
                                this.initialTracking.push(track)
                            }
                        } else {
                            this.orderDetails.trackingNumbers = [];
                            this.initialTracking = [];
                        }
                        this.sendEmail = !this.orderDetails.suppressEmails;
                        this.initialSendEmail = !this.orderDetails.suppressEmails;
                        this.orderDetails.taxApplied = this.orderDetails.taxApplied.toFixed(2)

                        this.orderDetails.totalPrice = this.orderDetails.totalPrice.toFixed(2)
                        this.orderDetails.shippingOption.price = this.orderDetails.shippingOption.price.toFixed(2)
                        this.orderDetails.discountApplied = this.orderDetails.discountApplied.toFixed(2)
                        this.getCompanyDetails();
                    })
            },
            setTimeToLocal(data) {

                let dateHistoryTime = new Date(data.getTime());

                if (dateHistoryTime.getHours() > 12) {
                    let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                    if (dateHistoryTime.getMinutes() == 59) {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    } else {
                        var hoursHistory = tempHour + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' PM'
                    }
                } else {
                    if (dateHistoryTime.getHours() == 0) {
                        var hoursHistory = '12' + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                    } else {
                        var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                    }
                }

                let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;

                return finalDate;
            },
            addTracking() {
                this.orderDetails.trackingNumbers.push(this.newTracking);
                this.newTracking = '';
                this.checkTracking();
            },
            removeTracking(tracking) {
                this.orderDetails.trackingNumbers.splice(this.orderDetails.trackingNumbers.indexOf(tracking), 1);
                this.checkTracking();
            },
            compareArrays(array1, array2) {
                if (array1.length != array2.length) {
                    return false;
                } else if (array1.length == array2.length) {
                    let compare = true;
                    for (let i = 0; i < array1.length; i++) {
                        if (array1[i] != array2[i])
                            compare = false;
                    }
                    return compare;
                }
            },
            checkSendEmail() {
                if (this.initialSendEmail != this.sendEmail) {
                    this.noChange.emails = false
                } else {
                    this.noChange.emails = true
                }
            },
            checkStatus() {
                console.log(this.initialStatus)
                console.log(this.currentStatus)
                if (this.initialStatus != this.currentStatus) {
                    this.noChange.status = false
                } else {
                    this.noChange.status = true
                }
            },
            checkTracking() {
                if (this.orderDetails.trackingNumbers.length == this.initialTracking.length) {
                    let trackingDiff = 0;
                    for (let track of this.orderDetails.trackingNumbers) {
                        if (this.orderDetails.trackingNumbers.indexOf(track) > -1) {
                            trackingDiff++;
                        }
                    }
                    if (trackingDiff != this.orderDetails.trackingNumbers.length) {
                        this.noChange.tracking = false
                    } else {
                        this.noChange.tracking = true
                    }
                } else {
                    this.noChange.tracking = false;
                }
            },
            sendChanges() {
                this.loading = true;

                let readyCheck = 0;
                if (this.noChange.emails == false) {
                    Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/suppress-emails/' + !this.sendEmail)
                        .then(response => {
                            readyCheck = readyCheck + 1;
                            if (readyCheck == 3) {
                                this.loading = false;
                                this.backToOrderManagement()
                            }
                        })
                        .catch(error => {
                            readyCheck = readyCheck + 1;
                            if (readyCheck == 3) {
                                this.loading = false;
                            }
                            console.log(error)
                        })
                } else {
                    readyCheck = readyCheck + 1;
                    if (readyCheck == 3) {
                        this.loading = false;
                        this.backToOrderManagement()
                    }
                }

                if (this.noChange.status == false) {
                    if (this.currentStatus == 'CREATED') {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/create')
                            .then(response => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else if (this.currentStatus == 'CONFIRMED') {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/mark-as-confirmed')
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else if (this.currentStatus == 'PAID') {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/mark-as-paid')
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else if (this.currentStatus == 'PACKED') {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/pack')
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else if (this.currentStatus == 'SHIPPED' && !(this.orderDetails.trackingNumbers.length > 0 && (this.orderDetails.trackingNumbers.length != this.initialTracking.length || trackingDiff != this.orderDetails.trackingNumbers.length))) {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/ship')
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else if (this.currentStatus == 'COMPLETED') {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/complete')
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else if (this.currentStatus == 'CANCELLED') {
                        Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/cancel')
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Order status changed',
                                    text: 'Order status has been changed successfully.',
                                    duration: 5000,
                                });
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                    this.backToOrderManagement()
                                }
                            })
                            .catch(error => {
                                readyCheck = readyCheck + 1;
                                if (readyCheck == 3) {
                                    this.loading = false;
                                }
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Order status not changed',
                                    text: 'Something went wrong during changing order status. Please, contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else {
                        readyCheck = readyCheck + 1;
                        if (readyCheck == 3) {
                            this.loading = false;
                            this.backToOrderManagement()
                        }
                    }
                } else {
                    readyCheck = readyCheck + 1;
                    if (readyCheck == 3) {
                        this.loading = false;
                        this.backToOrderManagement()
                    }
                }

                let trackingDiff = 0;
                if (this.orderDetails.trackingNumbers.length == this.initialTracking.length) {
                    for (let track of this.orderDetails.trackingNumbers) {
                        if (this.orderDetails.trackingNumbers.indexOf(track) > -1) {
                            trackingDiff++;
                        }
                    }
                }

                if (this.orderDetails.trackingNumbers.length > 0 && (this.orderDetails.trackingNumbers.length != this.initialTracking.length || trackingDiff != this.orderDetails.trackingNumbers.length)) {
                    let trackings = JSON.stringify(this.orderDetails.trackingNumbers);
                    trackings = trackings.replace('[', '');
                    trackings = trackings.replace(']', '');
                    trackings = trackings.split('"').join('');
                    Axios.patch(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/ship/' + trackings)
                        .then(response => {
                            readyCheck = readyCheck + 1;
                            if (readyCheck == 3) {
                                this.loading = false;
                                this.backToOrderManagement()
                            }
                            this.initialTracking = [];
                            for (let track of this.orderDetails.trackingNumbers) {
                                this.initialTracking.push(track)
                            }
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Tracking numbers changed',
                                text: 'Tracking has been changed successfully.',
                                duration: 5000,
                            });
                        })
                        .catch(error => {
                            readyCheck = readyCheck + 1;
                            if (readyCheck == 3) {
                                this.loading = false;
                            }
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Tracking numbers not changed',
                                text: 'Something went wrong during changing tracking number. Please contact support.',
                                duration: 5000,
                            });
                            console.log(error)
                        })
                } else if (this.orderDetails.trackingNumbers.length == 0 && this.initialTracking.length != 0) {
                    let parsedInitialTracking = '';
                    for (let track of this.initialTracking) {
                        parsedInitialTracking = parsedInitialTracking + String(track) + ','
                    }
                    parsedInitialTracking = parsedInitialTracking.slice(0, -1);
                    Axios.delete(globalStore.data.restApiUrl + '/orders/' + this.orderId + '/track/' + parsedInitialTracking)
                        .then(response => {
                            readyCheck = readyCheck + 1;
                            if (readyCheck == 3) {
                                this.loading = false;
                                this.backToOrderManagement()
                            }
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Tracking numbers deleted',
                                text: 'Tracking has been cleared successfully.',
                                duration: 5000,
                            });
                        })
                        .catch(error => {
                            readyCheck = readyCheck + 1;
                            if (readyCheck == 3) {
                                this.loading = false;
                            }
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Tracking numbers not cleared',
                                text: 'Something went wrong during clearing tracking number. Please contact support.',
                                duration: 5000,
                            });
                            console.log(error)
                        })
                } else {
                    readyCheck = readyCheck + 1;
                    if (readyCheck == 3) {
                        this.loading = false;
                        this.backToOrderManagement()
                    }
                }
            },
            validatedCount(value) {
                this.coldStockValidated = value;
            },
            changeSendEmail() {
                if (this.initialSendEmail != this.sendEmail) {
                    this.changed.sendEmail = true;
                } else {
                    this.changed.sendEmail = false;
                }
            },
            changeTracking() {
                let trackingDiff = 0;
                if (this.orderDetails.trackingNumbers.length == this.initialTracking.length) {
                    for (let track of this.orderDetails.trackingNumbers) {
                        if (this.orderDetails.trackingNumbers.indexOf(track) > -1) {
                            trackingDiff++;
                        }
                    }
                    if (trackingDiff != this.orderDetails.trackingNumbers.length) {
                        this.changed.tracking = true
                    } else {
                        this.changed.tracking = false
                    }
                } else {
                    this.changed.tracking = true
                }
            },
            changeOrderDetails() {
                if (this.initialStatus != this.currentStatus) {
                    this.changed.orderDetails = true;
                } else {
                    this.changed.orderDetails = false;
                }
            },
            getCompanyDetails() {
                Axios.get(`${globalStore.data.restApiUrl}/account/company-displayed-carriers?companyId=${this.orderDetails.companyId}`)
                    .then(response => {
                        for (let carrier of response.data) {
                            if (carrier == 1) {
                                this.simonCarrierAvailable = true
                            } else if (carrier == 2) {
                                this.tmobileCarrierAvailable = true
                            } else if (carrier == 3) {
                                this.vodafoneCarrierAvailable = true
                            } else if (carrier == 4) {
                                this.koreCarrierAvailable = true
                            }
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting carriers access error',
                            text: 'An error has occured during getting access to company\'s carrier config. There are possible some cold stock adding errors. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            }
        },
        mounted() {
            this.orderId = this.$route.params.id;
            this.getOrderDetails(this.orderId);
        }
    }
</script>

<style lang="scss">
    .breadcrumb {
        .breadcrumb-item {
            a[href="#/admin"]{
                display: none;
            }

            &:nth-child(2){
                padding-left: 0;

                &:before {
                    content: '';
                }
            }
        }
    }

    // custom scroll
    /* width */
    ::-webkit-scrollbar {
        width: 6px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #c9cfd4;
        border-radius: 3px;
        margin-right: 3px;
    }

    .edit-order-card {
        .card-body {
            padding: 0;

            .order-details-body {
                position: relative;
                display: flex;
                flex-direction: column;

                .order-details-content {
                    display: flex;

                    .order-details {
                        width: 15%;
                        padding-top: 20px;
                        margin-right: 40px;
                        border-right: 2px solid #F0F3F5;

                        h4 {
                            margin-top: 0;
                            padding-left: 20px;
                            font-size: 15px;
                            font-weight: 700;

                            span {
                                display: block;
                                font-size: 14px;
                                font-weight: 400;
                                padding: 8px 0 20px;
                            }
                        }

                        .about-client {
                            h4 {
                                margin-bottom: 0;
                                font-size: 14px;
                            }

                            .client-header {
                                padding: 20px;
                                background-color: #f0f3f5;
                                font-size: 14px;
                                font-weight: 700;
                                margin-bottom: 20px;
                            }

                            .client-name {
                                padding-left: 20px;
                                font-size: 14px;
                                font-weight: 700;
                                margin-bottom: 0;
                            }

                            .client-contact-header,
                            .client-contact-number,
                            .client-data {
                                padding-left: 20px;
                                font-size: 14px;
                                margin: 0;
                                line-height: 24px;
                                font-weight: 700;
                            }

                            .client-contact-header {
                                margin-top: 18px;
                                font-weight: 400;
                            }
                        }

                        .edit-order-status {
                            display: flex;
                            flex-direction: column;

                            h4 {
                                padding: 18px 20px 18px;
                                background-color: #f0f3f5;
                                font-size: 14px;
                                margin: 20px 0 0;
                            }

                            h5 {
                                padding: 10px 20px;
                                font-size: 14px;
                            }

                            .custom-control-inline {
                                padding-bottom: 10px;


                                input[type="radio"] {
                                    display: none;

                                    &:checked + label::after {
                                        content: '';
                                        position: absolute;
                                        left: 4px;
                                        top: 8px;
                                        width: 8px;
                                        height: 8px;
                                        background-color: #2F353A;
                                        border-radius: 50%;
                                    }
                                }

                                label {
                                    position: relative;
                                    cursor: pointer;
                                    margin: 0;
                                    padding-left: 40px;

                                    &::before {
                                        content: '';
                                        display: block;
                                        position: absolute;
                                        left: 0;
                                        top: 4px;
                                        width: 16px;
                                        height: 16px;
                                        border: 2px solid #2F353A;
                                        border-radius: 50%;
                                        background-color: #fff;
                                    }

                                    &::after {
                                        background-image: none;
                                    }
                                }
                            }

                        }
                    }

                    .temp-class {
                        width: 85%;

                        .ordered-items {
                            height: calc(100vh - 275px);
                            overflow: auto;
                            padding-right: 20px;
                            -webkit-margin-end: 3px; // 3px -> caused by custom scroll
                            -webkit-margin-before: 3px; // 3px -> caused by custom scroll

                            h4 {
                                margin-top: 18px;
                                font-size: 14px;
                                font-weight: 700;
                            }

                            .order-header,
                            .order-tax,
                            .order-shipment,
                            .order-ship-address,
                            .cold-stock,
                            .tracking-control,
                            .payment,
                            .order-total {
                                display: flex;
                                justify-content: space-between;
                                padding-bottom: 20px;
                                border-bottom: 1px solid #dfe2e5;
                            }

                            .order-header {
                                padding-top: 20px;
                                -webkit-padding-before: 17px; // for chrome
                                border: none;
                                align-items: center;
                                justify-content: flex-end;

                                .fa-close {
                                    cursor: pointer;
                                }
                            }

                            .cold-stock {
                                div {
                                    border: none;

                                    .validated {
                                        margin-left: 5px;

                                        &.success {
                                            color: #00B406;
                                        }

                                        &.fail {
                                            color: #d10505;
                                        }
                                    }
                                }
                            }

                            .tracking-control {
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                padding-top: 20px;

                                div {
                                    display: flex;
                                    align-items: center;
                                    margin-right: 20px;
                                    border: none;

                                    &.add-tracking {
                                        input {
                                            border: 1px solid #ffd86b;
                                            -webkit-border-radius: 5px;
                                            -moz-border-radius: 5px;
                                            border-radius: 5px;
                                            border-top-right-radius: 0;
                                            border-bottom-right-radius: 0;
                                            padding: 8px;
                                        }

                                        button {
                                            border: 1px solid #ffd86b;
                                            -webkit-border-radius: 5px;
                                            -moz-border-radius: 5px;
                                            border-radius: 5px;
                                            border-top-left-radius: 0;
                                            border-bottom-left-radius: 0;
                                            background-color: #ffd86b;
                                            padding: 8px 16px;
                                        }
                                    }

                                    &.tracking-number {

                                        .fa-close {
                                            cursor: pointer;
                                            margin-left: 5px;
                                        }

                                    }
                                }
                            }

                            .payment {
                                display: flex;

                                .card-info {
                                    width: 50%;
                                    justify-content: flex-start;
                                    align-items: center;
                                    border-bottom: none;

                                    .card-number {
                                        margin-left: 16px;
                                    }
                                }

                                .payment-status-box {
                                    width: 50%;
                                    justify-content: flex-start;
                                    align-items: center;
                                    border-bottom: none;

                                    .payment-status {
                                        font-weight: 500;
                                        margin-right: 10px;

                                        &.succes {
                                            color: #55cd6c;
                                        }

                                        &.failed {
                                            color: #FC4D4D;
                                        }
                                    }
                                }
                            }

                            .order-total {
                                flex-direction: column;
                                align-items: flex-end;
                                margin-top: 50px;
                                border-bottom: 0;
                            }
                        }

                        .control-bar {
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            padding: 20px;
                            border-top: 1px solid #dfe2e5;

                            label {
                                margin: 0 10px;
                            }

                            .control-bar {
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                padding: 20px;

                                label {
                                    margin: 0 10px;
                                }

                                .btn-light,
                                .btn-success {
                                    width: 100px;
                                    margin-left: 10px;
                                }
                            }
                        }
                    }


                    .loader-request-execution {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;

                        background-color: rgba(255, 255, 255, 0.7);

                        display: flex;
                        justify-content: center;
                        align-items: center;
                        align-content: center;
                        flex-direction: column;

                        .sk-wave {
                            height: 60px;

                            .sk-rect {
                                width: 3px;
                                background-color: #39c354;
                                border-radius: 4px;
                            }
                        }

                        .text {
                            margin-top: 20px;
                            text-align: center;
                            font-size: 15px;
                            font-weight: 700;
                        }
                    }
                }

                .summary-table {
                    width: 100%;
                    table-layout: fixed;

                    th {
                        padding-bottom: 10px;

                        &:nth-child(1) {
                            width: 50%;
                        }

                        &:nth-child(2) {
                            width: 20%;
                        }

                        &:nth-child(3) {
                            width: 10%;
                        }

                        &:nth-child(4) {
                            width: 10%;
                        }

                        &:nth-child(5) {
                            width: 10%;
                        }

                        &:nth-child(n+2) {
                            text-align: right;
                        }
                    }


                    tbody {
                        tr {
                            border-top: 1px solid #dfe2e5;
                            border-bottom: 1px solid #dfe2e5;

                            td {
                                padding: 16px 0;
                            }
                        }

                        .cost-row {
                            td {
                                &:nth-child(n+2) {
                                    text-align: right;
                                }

                                &:nth-child(4)::before {
                                    content: '$ ';
                                }

                                img {
                                    height: 20px;
                                    width: auto;
                                }
                                .light-mode {
                                    display: initial;
                                }
                                .dark-mode {
                                    display: none;
                                }
                                .item-box {
                                    display: flex;
                                    .img-box {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .total-row {
                            font-weight: 700;
                            border: none;
                            border-top: 2px solid;

                            td {
                                font-weight: 400;

                                &:nth-child(4)::before {
                                    content: '$ ';
                                }
                            }
                        }
                    }
                }

                .summary-title {
                    font-size: 16px;
                }

                .summary-header {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    h3 {
                        font-size: 1em;
                        display: inline-block;
                    }
                }

                .summary-line {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    border-top: 1px solid #dfe2e5;
                    padding-top: 10px;

                    .summary-money {
                        &:before {
                            content: '$ ';
                        }
                    }

                    &:first-child {
                        border-top: 0;
                    }

                    &:last-child {
                        border-top: 2px solid #073553;
                    }
                }
            }
        }
    }



    #selectCarrier___BV_modal_body_ {
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;

        padding-top: 0;
        padding-bottom: 40px;

        .close-bar {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding: 20px 0;

            i {
                cursor: pointer;
            }
        }

        img {
            max-width: 16px;
            margin-bottom: 12px;
        }

        strong {
            margin-bottom: 18px;
            font-size: 15px;
            line-height: 20px;
        }

        p {
            font-size: 14px;
            line-height: 24px;
        }

        .select-carrier-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .carrier-option {
                width: 180px;
                padding: 10px 20px;
                margin-bottom: 10px;

                border: 1px solid #80868D;
                border-radius: 5px;
                text-align: center;
                box-sizing: border-box;
                cursor: pointer;
                opacity: .6;

                &:hover {
                    opacity: 1;
                }

                label {
                    display: block;
                    margin: 0;
                    img {
                        width: 100%;
                        max-width: none;
                        margin: 0;
                        cursor: pointer;
                        &.light-mode {
                            display: block;
                        }
                        &.dark-mode {
                            display: none;
                        }
                    }
                }


            }
        }
    }

    #unsavedChanges___BV_modal_content_,
    #unsavedOrderEdition___BV_modal_content_ {
        .modal-body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1rem;
            text-align: center;

            i {
                color: #0088FF;
                margin-bottom: 15px;
            }

            img {
                height: 19px;
                width: auto;
                margin-bottom: 15px;
            }

            h3 {
                display: block;
                margin-bottom: 18px;
                font-size: 15px;
                line-height: 18px;
                font-weight: 700;
                color: #2F353A;
            }

            h4 {
                display: block;
                margin-bottom: 20px;
                font-size: 14px;
                line-height: 24px;
                color: #515B65;
            }

            .button-wrapper {
                button {
                    margin: 0 5px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }
    }

    .dark-theme {
        .edit-order-card {
            .card-body {
                .order-details-body {
                    .order-details-content {
                        .order-details {
                            border-right-color: #2f353a;

                            .client-header {
                                background-color: #2f353a;
                            }

                            .edit-order-status {
                                h4 {
                                    background-color: #2f353a;
                                }
                            }
                        }

                        .ordered-items {
                            tbody {
                                tr {
                                    border-top-color: #2f353a;
                                    border-bottom-color: #2f353a;
                                    td {
                                        .light-mode {
                                            display: none;
                                        }
                                        .dark-mode {
                                            display: initial;
                                        }
                                    }
                                }
                            }

                            .order-header,
                            .order-tax,
                            .order-shipment,
                            .order-ship-address,
                            .cold-stock,
                            .tracking-control,
                            .payment,
                            .order-total {
                                border-bottom-color: #2f353a;
                            }

                            .tracking-control {
                                .add-tracking {
                                    input {
                                        background-color: #515b65;
                                        color: #edeeef;

                                        &::placeholder {
                                            color: #dcdcdc;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .temp-class {
                    .control-bar {
                        border-color: #1a1c1d;
                    }
                }
            }
        }
        #selectCarrier___BV_modal_body_, {
            background-color: #3a4149;
            color: #ffffff;
            #selectCarrier___BV_modal_header_ {
                border-color: #1a1c1d;
            }

            .select-carrier-box {
                .carrier-option {
                    border-color: #1a1c1d;
                    label {
                        img {
                            &.light-mode {
                                display: none;
                            }
                            &.dark-mode {
                                display: block;
                            }
                        }
                    }
                }
            }
        }


        #unsavedOrderEdition___BV_modal_content_ {
            .modal-body {
                background-color: #3a4149;
                color: #ffffff;
                i {
                    color: #ffffff;
                }

                h3 {
                    color: #ffffff;
                }

                h4 {
                    color: #ffffff;
                }
            }
        }
    }


.coupon-information {
        padding-bottom: 20px;
    border-bottom: 1px solid #dfe2e5;
}
</style>
